import { useTranslation } from 'react-i18next';

import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import { Timeline } from 'primereact/timeline';

import PropTypes from 'prop-types';
import React from 'react';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { REGISTER_RESULT_STATUSES, TIMEZONE_VN } from 'constant';
import { getAcadamicLevelShortHand, toCamelCaseString } from 'utils/func';

dayjs.extend(timezone);
dayjs.extend(utc);

function RegisterResultReviewHistory({ data, visible, setVisible, title }) {
  const { t } = useTranslation();

  const addPostFix = (action, status) => {
    if (status === REGISTER_RESULT_STATUSES.SUBMITTED) return '';
    if (action === REGISTER_RESULT_STATUSES.RESET) return '.approved';
    if (action === REGISTER_RESULT_STATUSES.APPROVED) return '.approved';
    if (action === REGISTER_RESULT_STATUSES.REJECTED) return '.rejected';
    return '';
  };

  const formatAction = ({ previousStatus, newStatus, action }) => (
    <div className="flex align-items-center gap-2 justify-content-end">
      <Tag
        style={{
          background: 'var(--gray-500)',
        }}
        value={
          <del>
            {t(
              `registerResult.reviewHistory.status.${toCamelCaseString(previousStatus)}${addPostFix(
                action,
                previousStatus
              )}`
            )}
          </del>
        }
        rounded
        className="text-center"
      />
      <i className="pi pi-arrow-right" style={{ fontSize: '1rem' }} />
      <Tag
        style={{
          background: 'var(--blue-500)',
        }}
        value={t(
          `registerResult.reviewHistory.status.${toCamelCaseString(newStatus)}${addPostFix(
            action,
            newStatus
          )}`
        )}
        rounded
        className="text-center"
      />
    </div>
  );
  const formatContent = ({ changedBy, changeAt }) => (
    <small className="text-color-secondary">
      {getAcadamicLevelShortHand(
        changedBy?.contacts?.[0]?.scientificProfile?.academicRank,
        changedBy?.contacts?.[0]?.scientificProfile?.academicDegree,
        t,
        true
      )}{' '}
      {changedBy?.contacts?.[0]?.fullname} ({changedBy?.contacts?.[0]?.email}) -{' '}
      {dayjs(changeAt).tz(TIMEZONE_VN).format('DD/MM/YYYY HH:mm')}
    </small>
  );

  return (
    <Dialog
      header={<p className="text-blue-500">{title}</p>}
      visible={visible}
      position="center"
      style={{ width: '100vh', margin: '1rem' }}
      onHide={() => setVisible(false)}
      draggable={false}
    >
      {data.length > 0 && (
        <div className="flex flex-column gap-4">
          {data.map((item, index) => (
            <div key={'register-result-review-history-item-'.concat(index)}>
              <Timeline value={item} opposite={formatAction} content={formatContent} />
              {index !== data.length - 1 && (
                <hr className="mt-4 mb-0 mx-0 w-full surface-400 text-center" />
              )}
            </div>
          ))}
        </div>
      )}
    </Dialog>
  );
}

export default React.memo(RegisterResultReviewHistory);

RegisterResultReviewHistory.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
